import React from 'react';
import { Rss, Globe } from 'lucide-react';

interface RSSFeedDiscoveryProps {
  feedUrl: string;
  feedName: string;
  showIcon?: boolean;
  showText?: boolean;
}

const RSSFeedDiscovery: React.FC<RSSFeedDiscoveryProps> = ({
  feedUrl,
  feedName,
  showIcon = true,
  showText = true
}) => {
  const handleRSSClick = () => {
    // Open RSS feed in new tab
    window.open(feedUrl, '_blank');
  };

  const handleAtomClick = () => {
    // Open Atom feed in new tab (if available)
    const atomUrl = feedUrl.replace('.xml', '.atom');
    window.open(atomUrl, '_blank');
  };

  return (
    <div className="flex items-center gap-2 text-sm text-gray-600">
      {showIcon && (
        <Rss className="w-4 h-4 text-orange-500" />
      )}
      {showText && (
        <span>Subscribe to {feedName}</span>
      )}
      <div className="flex items-center gap-1">
        <button
          onClick={handleRSSClick}
          className="px-2 py-1 text-xs bg-orange-100 text-orange-700 rounded hover:bg-orange-200 transition-colors flex items-center gap-1"
          title="RSS Feed"
        >
          <Rss className="w-3 h-3" />
          RSS
        </button>
        <button
          onClick={handleAtomClick}
          className="px-2 py-1 text-xs bg-blue-100 text-blue-700 rounded hover:bg-blue-200 transition-colors flex items-center gap-1"
          title="Atom Feed"
        >
          <Globe className="w-3 h-3" />
          Atom
        </button>
      </div>
    </div>
  );
};

export default RSSFeedDiscovery;
